import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
const Status = ({
  setCommunicationSave,
  isCommunicationSave,
  isOnlyTimeSlip,
  isOnlyDocs,
  showSuccess,
  msg,
  onOk,
  mode,
}) => {
  useEffect(() => {
    SetShowSuccess(showSuccess);
    SetMsg(msg);
    SetMode(mode)
  }, [showSuccess]);

  const [IsSuccess, SetShowSuccess] = useState(true);
  const [Mode, SetMode] = useState(0);
  const [message, SetMsg] = useState("Logged");
  const handleClose = () => {
  
    SetShowSuccess(false);
   
    onOk(false, IsSuccess, Mode);
  };
  const size = 100;
  return (
    <div
  className="flex flex-col justify-center items-center h-full"
  style={{ textAlign: "center" }}
>
  {IsSuccess && (
    <img
      src="../../assets/success.jpg"
      style={{ width: `${size * 2}px`, height: `${size * 2}px` }}
    />
  )}
  {!IsSuccess && (
    <img
      src="../../assets/Faillure.png"
      alt="Failure"
      style={{ width: `${size}px`, height: `${size}px` }}
    />
  )}
  <p>{message}</p>
  {(
    <div className="flex justify-center items-center mt-4">
      <button
        type="button"
        className="px-6 py-2 border rounded-lg hover:bg-gray-50"
        onClick={handleClose}>
        OK
      </button>
    </div>
  )}
</div>
  );
};

export default Status;
